import React, { useState, useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { UserContext } from '../../context/User';
import { useHistory } from "react-router-dom";
import Loading from '../Loading';
import { somethingWentWrongNotice } from '../UI/Notifications';
import AlertMessage from '../AlertMessage';
import classes from './index.module.scss';
import DateRange from 'components/UI/DateRange';
import { opportunityReportsGet } from '../../api';
import date from 'date-and-time';

const INITIAL_DATE = date.format(new Date, 'YYYY-MM-DD')

const OpportunityReports = () => {
  const [loading, setLoading] = useState(false);
  const { setUser, setIsLoggedIn } = useContext(UserContext);
  const history = useHistory();

  const [count, setCount] = useState(0);
  const [fromDate, setFromDate] = useState(INITIAL_DATE);
  const [toDate, setToDate] = useState(INITIAL_DATE);
  const [showMessage, setShowMessage] = useState(false);

  const MATCHING_REPORTS_ALERT = `
    <div>
      <p class="mb-0">
        The total processed opportunities between ${fromDate} and ${toDate} is ${count}.
      </p>
    </div>
    `;

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push('/');
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout()
    } else {
      somethingWentWrongNotice("Business Reports");
    }

    setLoading(false);
  }

  const handleTimeCallback = (start, end) => {
    setShowMessage(false);
    setFromDate(date.format(start._d, 'YYYY-MM-DD'));
    setToDate(date.format(end._d, 'YYYY-MM-DD'));
  }   

  const params = {
    from_date: fromDate,
    to_date: toDate
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    opportunityReportsGet(params).then(response => {
      setCount(response.data.total);
      setShowMessage(true);
      setLoading(false);
    })
    .catch(error => {
      if(error.response.status === 404) { 
        setCount(0); 
        setShowMessage(true); 
        setLoading(false);
      } else {
        handleDefaultStatusCodes(error.response.status); 
      }
    })
  }

  return (
    <section className={`${classes.Matching_Reports_Title} section-spaces`}>
      <Container>
        <Row>
          <Col>
            <h3 className={`${classes.Matching_Reports_Title}`}>Opportunities Reports</h3>
            { showMessage && <AlertMessage alertMessage={MATCHING_REPORTS_ALERT} styleClass='Alert_Message_MatchingReports' showCloseIcon={false} /> }
            <p>Select the date range to find the number of opportunities processed occurred within that range</p>
            <form onSubmit={handleSubmit}>          
              <div className={`${classes.Matching_Reports_Body}`}> 
                <Row>
                  <Col>
                      <h5>Date</h5>
                  </Col>
                  <Col>
                    <div className={`${classes.DateRangeWrap}`} >
                      <DateRange 
                        handleTimeCallback={handleTimeCallback}
                        name="date"
                        id="posted_date"
                        inputStyle={classes.SearchDateRange}
                        cancelCallback = {() => {
                          setFromDate(INITIAL_DATE);
                          setToDate(INITIAL_DATE);
                          setShowMessage(false); 
                        }}
                        isPicked = {()=>{}}
                      />
                    </div>
                  </Col>
                </Row>    
              </div>
              <div className={`${classes.Matching_Reports_Submit}`}>
                <button type='submit' className='filledBtn btnSizes px-5 py-3'>
                  Submit
                </button>
              </div>
            </form>
          </Col>
        </Row>
        {loading && <Loading />}
      </Container>    
    </section>
  )
}

export default OpportunityReports;
 